import { render } from "./PropertyAgriculture.vue?vue&type=template&id=53e25f40"
import script from "./PropertyAgriculture.vue?vue&type=script&lang=js"
export * from "./PropertyAgriculture.vue?vue&type=script&lang=js"

import "./PropertyAgriculture.vue?vue&type=style&index=0&id=53e25f40&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__